
/*!
* Copyright (c) Microsoft Corporation.
* All rights reserved. See LICENSE in the project root for license information.
* THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
* TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
*/
// tslint:disable
// import { AsyncResult, callActionOrExecute, DataServiceQuery, IContext, IDataServiceRequest, IQueryResultSettings, NullResult } from '@msdyn365-commerce/retail-proxy';
import { AsyncResult, callActionOrExecute, DataServiceQuery, IContext, IDataServiceRequest, IQueryResultSettings } from '@msdyn365-commerce/retail-proxy';
// @ts-ignore
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';

// import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
// import * as DataServiceEntities from './DataServiceEntities.g';


function startsWithUpperQuery(): DataServiceQuery {
  return new DataServiceQuery();
}

export function startsWithUpperInput(str: string): IDataServiceRequest {
  const query = startsWithUpperQuery();

  return query.createDataServiceRequestForOperation(
    'StartsWithUpper', false, ''
    , 'false', 
    { bypassCache: 'none', returnEntity: 'boolean' }, 
    { str: str }
  );
}

export function startsWithUpperAsync(context: IContext, str: string): AsyncResult<boolean> {
  const request = startsWithUpperInput(str);

  return callActionOrExecute<boolean>(request, context.callerContext);
}

function getByCustomerAllBTGPTransactionFromHqQuery(): DataServiceQuery {
  return new DataServiceQuery();
  }


export function getByCustomerAllBTGPTransactionFromHqInput (
queryResultSettings: IQueryResultSettings, isUat:
    boolean,
    customerId:
    string,
    customerEmail:
    string,
    organisation:
    string
): IDataServiceRequest {
const query = getByCustomerAllBTGPTransactionFromHqQuery().resultSettings(queryResultSettings);
return query.createDataServiceRequestForOperation(
  'GetByCustomerAllBTGPTransactionFromHq',
  false, 
    ''
  ,
  'true',
  { bypassCache: 'get', returnEntity: 'string[]' },
  { 
  isUat: isUat,
    customerId: customerId,
    customerEmail: customerEmail,
    organisation: organisation
  }
);
}

export function getByCustomerAllBTGPTransactionFromHqAsync (
context: IContext, isUat:
    boolean,
    customerId:
    string,
    customerEmail:
    string,
    organisation:
    string
): AsyncResult<string[]> {
const request = getByCustomerAllBTGPTransactionFromHqInput(
  context.queryResultSettings || { Paging: { Top: 10000 } }, isUat, customerId, customerEmail, organisation);
return callActionOrExecute<string[]>(request, context.callerContext);
}

function getHtmlByProductNumberQuery(): DataServiceQuery {
  return new DataServiceQuery();
}

export function getHtmlByProductNumberInput(env: string,  entity: string,  containerName: string,  productNumber: string): IDataServiceRequest {
  const query = getHtmlByProductNumberQuery();

  return query.createDataServiceRequestForOperation(
    'GetHtmlByProductNumber', false, '', 'false', 
    { bypassCache: 'none', returnEntity: 'string' }, 
    { env: env, entity: entity, containerName: containerName, productNumber: productNumber }
  );
}

export function getHtmlByProductNumberAsync(context: IContext, env: string,  entity: string,  containerName: string,  productNumber: string): AsyncResult<string> {
  const request = getHtmlByProductNumberInput(env, entity, containerName, productNumber);

  return callActionOrExecute<string>(request, context.callerContext);
}

function getTodayScheduleQuery(): DataServiceQuery {
  return new DataServiceQuery();
}

export function getTodayScheduleInput(queryResultSettings: IQueryResultSettings, env: string,  entity: string,  containerName: string,  blobName: string,  libraryName: string): IDataServiceRequest {
  const query = getTodayScheduleQuery().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'GetTodaySchedule', false, '', 'true', 
    { bypassCache: 'none', returnEntity: 'string[]' }, 
    { env: env, entity: entity, containerName: containerName, blobName: blobName, libraryName: libraryName }
  );
}

export function getTodayScheduleAsync(context: IContext, env: string,  entity: string,  containerName: string,  blobName: string,  libraryName: string): AsyncResult<string[]> {
  const request = getTodayScheduleInput(context.queryResultSettings || {}, env, entity, containerName, blobName, libraryName);

  return callActionOrExecute<string[]>(request, context.callerContext);
}

function getCalendarEventsQuery(): DataServiceQuery {
  return new DataServiceQuery();
}

export function getCalendarEventsInput(queryResultSettings: IQueryResultSettings, isUat: boolean,  locale: string,  organisation: string,  startDate: string,  endDate: string): IDataServiceRequest {
  const query = getCalendarEventsQuery().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'GetCalendarEvents', false, '', 'true', 
    { bypassCache: 'none', returnEntity: 'string[]' }, 
    { isUat: isUat, locale: locale, organisation: organisation, startDate: startDate, endDate: endDate }
  );
}

export function getCalendarEventsAsync(context: IContext, isUat: boolean,  locale: string,  organisation: string,  startDate: string,  endDate: string): AsyncResult<string[]> {
  const request = getCalendarEventsInput(context.queryResultSettings || {}, isUat, locale, organisation, startDate, endDate);

  return callActionOrExecute<string[]>(request, context.callerContext);
}

function getUpcomingEventsQuery(): DataServiceQuery {
  return new DataServiceQuery();
}

export function getUpcomingEventsInput(queryResultSettings: IQueryResultSettings, isUat: boolean,  locale: string,  organisation: string,  startDate: string,  endDate: string): IDataServiceRequest {
  const query = getUpcomingEventsQuery().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'GetUpcomingEvents', false, '', 'true', 
    { bypassCache: 'none', returnEntity: 'string[]' }, 
    { isUat: isUat, locale: locale, organisation: organisation, startDate: startDate, endDate: endDate }
  );
}

export function getUpcomingEventsAsync(context: IContext, isUat: boolean,  locale: string,  organisation: string,  startDate: string,  endDate: string): AsyncResult<string[]> {
  const request = getUpcomingEventsInput(context.queryResultSettings || {}, isUat, locale, organisation, startDate, endDate);

  return callActionOrExecute<string[]>(request, context.callerContext);
}

function getUpcomingEventsByTypeQuery(): DataServiceQuery {
  return new DataServiceQuery();
}

export function getUpcomingEventsByTypeInput(queryResultSettings: IQueryResultSettings, isUat: boolean,  locale: string,  organisation: string,  typeNo: string,  startDate: string,  endDate: string): IDataServiceRequest {
  const query = getUpcomingEventsByTypeQuery().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'GetUpcomingEventsByType', false, '', 'true', 
    { bypassCache: 'none', returnEntity: 'string[]' }, 
    { isUat: isUat, locale: locale, organisation: organisation, typeNo: typeNo, startDate: startDate, endDate: endDate }
  );
}

export function getUpcomingEventsByTypeAsync(context: IContext, isUat: boolean,  locale: string,  organisation: string,  typeNo: string,  startDate: string,  endDate: string): AsyncResult<string[]> {
  const request = getUpcomingEventsByTypeInput(context.queryResultSettings || {}, isUat, locale, organisation, typeNo, startDate, endDate);

  return callActionOrExecute<string[]>(request, context.callerContext);
}

function getUpcomingEventsByIdQuery(): DataServiceQuery {
  return new DataServiceQuery();
}

export function getUpcomingEventsByIdInput(queryResultSettings: IQueryResultSettings, isUat: boolean,  locale: string,  organisation: string,  startDate: string,  endDate: string,  ecommId: string): IDataServiceRequest {
  const query = getUpcomingEventsByIdQuery().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'GetUpcomingEventsById', false, '', 'true', 
    { bypassCache: 'none', returnEntity: 'string[]' }, 
    { isUat: isUat, locale: locale, organisation: organisation, startDate: startDate, endDate: endDate, ecommId: ecommId }
  );
}

export function getUpcomingEventsByIdAsync(context: IContext, isUat: boolean,  locale: string,  organisation: string,  startDate: string,  endDate: string,  ecommId: string): AsyncResult<string[]> {
  const request = getUpcomingEventsByIdInput(context.queryResultSettings || {}, isUat, locale, organisation, startDate, endDate, ecommId);

  return callActionOrExecute<string[]>(request, context.callerContext);
}

function getRenewableSerialsRequest(): DataServiceQuery {
  return new DataServiceQuery();
}

export function getRenewableSerialsInput(queryResultSettings: IQueryResultSettings, isUat: boolean,  ecommId: string,  email: string): IDataServiceRequest {
  const query = getRenewableSerialsRequest().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'GetRenewableSerials', true, '', 'false', 
    { bypassCache: 'none', returnEntity: 'string[]' }, 
    { isUat: isUat, ecommId: ecommId, email: email }
  );
}

export function getRenewableSerialsAsync(context: IContext, isUat: boolean,  ecommId: string,  email: string): AsyncResult<string[]> {
  const request = getRenewableSerialsInput(context.queryResultSettings || {}, isUat, ecommId, email);

  return callActionOrExecute<string[]>(request, context.callerContext);
}

function getBTGPTransactionRequest(): DataServiceQuery {
  return new DataServiceQuery();
}

export function getBTGPTransactionInput(queryResultSettings: IQueryResultSettings, transactionID: string): IDataServiceRequest {
  const query = getBTGPTransactionRequest().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'GetBTGPTransaction', true, '', 'false', 
    { bypassCache: 'none', returnEntity: 'string' }, 
    { transactionID: transactionID }
  );
}

export function getBTGPTransactionAsync(context: IContext, transactionID: string): AsyncResult<boolean> {
  const request = getBTGPTransactionInput(context.queryResultSettings || {}, transactionID);

  return callActionOrExecute<boolean>(request, context.callerContext);
}

function getAllBTGPTransactionRequest(): DataServiceQuery {
  return new DataServiceQuery();
}

export function getAllBTGPTransactionInput(queryResultSettings: IQueryResultSettings, salesOrderID: string): IDataServiceRequest {
  const query = getAllBTGPTransactionRequest().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'GetAllBTGPTransaction', true, '', 'false', 
    { bypassCache: 'none', returnEntity: 'string[]' }, 
    { salesOrderID: salesOrderID }
  );
}

export function getAllBTGPTransactionAsync(context: IContext, salesOrderID: string): AsyncResult<string[]> {
  const request = getAllBTGPTransactionInput(context.queryResultSettings || {}, salesOrderID);

  return callActionOrExecute<string[]>(request, context.callerContext);
}

function getByCustomerBTGPTransactionRequest(): DataServiceQuery {
  return new DataServiceQuery();
}

export function getByCustomerBTGPTransactionInput(queryResultSettings: IQueryResultSettings, customerID: string,  customerEmail: string,  productID: string,  isUAT: boolean): IDataServiceRequest {
  const query = getByCustomerBTGPTransactionRequest().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'GetByCustomerBTGPTransaction', true, '', 'false', 
    { bypassCache: 'none', returnEntity: 'string[]' }, 
    { customerID: customerID, customerEmail: customerEmail, productID: productID, isUAT: isUAT }
  );
}

export function getByCustomerBTGPTransactionAsync(context: IContext, customerID: string,  customerEmail: string,  productID: string,  isUAT: boolean): AsyncResult<string[]> {
  const request = getByCustomerBTGPTransactionInput(context.queryResultSettings || {}, customerID, customerEmail, productID, isUAT);

  return callActionOrExecute<string[]>(request, context.callerContext);
}

function getByCustomerAllBTGPTransactionRequest(): DataServiceQuery {
  return new DataServiceQuery();
}

export function getByCustomerAllBTGPTransactionInput(queryResultSettings: IQueryResultSettings, customerID: string,  customerEmail: string,  organisation: string,  isUAT: boolean,  numberOfRecords: number): IDataServiceRequest {
  const query = getByCustomerAllBTGPTransactionRequest().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'GetByCustomerAllBTGPTransaction', true, '', 'false', 
    { bypassCache: 'none', returnEntity: 'string[]' }, 
    { customerID: customerID, customerEmail: customerEmail, organisation: organisation, isUAT: isUAT, numberOfRecords: numberOfRecords }
  );
}

export function getByCustomerAllBTGPTransactionAsync(context: IContext, customerID: string,  customerEmail: string,  organisation: string,  isUAT: boolean,  numberOfRecords: number): AsyncResult<string[]> {
  const request = getByCustomerAllBTGPTransactionInput(context.queryResultSettings || {}, customerID, customerEmail, organisation, isUAT, numberOfRecords);

  return callActionOrExecute<string[]>(request, context.callerContext);
}

function getFirstSerialRequest(): DataServiceQuery {
  return new DataServiceQuery();
}

export function getFirstSerialInput(queryResultSettings: IQueryResultSettings, isUat: boolean,  ecommId: string,  businessUnit: string,): IDataServiceRequest {
  const query = getFirstSerialRequest().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'GetFirstSerial', true, '', 'false', 
    { bypassCache: 'get', returnEntity: 'string' }, 
    { isUat: isUat, ecommId: ecommId, businessUnit: businessUnit }
  );
}

export function getFirstSerialAsync(context: IContext, isUat: boolean,  ecommId: string,  businessUnit: string,): AsyncResult<string> {
  const request = getFirstSerialInput(context.queryResultSettings || {}, isUat, ecommId, businessUnit);

  return callActionOrExecute<string>(request, context.callerContext);
}

function checkSerialRequest(): DataServiceQuery {
  return new DataServiceQuery();
}

export function checkSerialInput(queryResultSettings: IQueryResultSettings, isUat: boolean,  ecommId: string,  businessUnit: string,  serialId: string): IDataServiceRequest {
  const query = checkSerialRequest().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'CheckSerial', true, '', 'false', 
    { bypassCache: 'get', returnEntity: 'string' }, 
    { isUat: isUat, ecommId: ecommId, businessUnit: businessUnit, serialId: serialId }
  );
}

export function checkSerialAsync(context: IContext, isUat: boolean,  ecommId: string,  businessUnit: string,  serialId: string): AsyncResult<string> {
  const request = checkSerialInput(context.queryResultSettings || {}, isUat, ecommId, businessUnit, serialId);

  return callActionOrExecute<string>(request, context.callerContext);
}

function checkAvailableSerialRequest(): DataServiceQuery {
  return new DataServiceQuery();
}

export function checkAvailableSerialInput(queryResultSettings: IQueryResultSettings, isUat: boolean,  ecommId: string): IDataServiceRequest {
  const query = checkAvailableSerialRequest().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'CheckAvailableSerial', true, '', 'false', 
    { bypassCache: 'none', returnEntity: 'string' }, 
    { isUat: isUat, ecommId: ecommId }
  );
}

export function checkAvailableSerialAsync(context: IContext, isUat: boolean,  ecommId: string): AsyncResult<string> {
  const request = checkAvailableSerialInput(context.queryResultSettings || {}, isUat, ecommId);

  return callActionOrExecute<string>(request, context.callerContext);
}

function updateBTGPCartLineRequest(): DataServiceQuery {
  return new DataServiceQuery();
}

export function updateBTGPCartLineInput(queryResultSettings: IQueryResultSettings, isUat: boolean,  cartLineId: string,  customerEmail: string): IDataServiceRequest {
  const query = updateBTGPCartLineRequest().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'UpdateBTGPCartLine', true, '', 'false', 
    { bypassCache: 'none', returnEntity: 'string' }, 
    { isUat: isUat, cartLineId: cartLineId, customerEmail: customerEmail }
  );
}

export function updateBTGPCartLineAsync(context: IContext, isUat: boolean,  cartLineId: string,  customerEmail: string): AsyncResult<string> {
  const request = updateBTGPCartLineInput(context.queryResultSettings || {}, isUat, cartLineId, customerEmail);

  return callActionOrExecute<string>(request, context.callerContext);
}

function createBTGPTransactionByCartRequest(): DataServiceQuery {
  return new DataServiceQuery();
}

export function createBTGPTransactionByCartInput(queryResultSettings: IQueryResultSettings, cartId: string,  salesOrderId: string,  customerId: string,  salesLineDataJSON: string): IDataServiceRequest {
  const query = createBTGPTransactionByCartRequest().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'CreateBTGPTransactionByCart', true, '', 'false', 
    { bypassCache: 'none', returnEntity: 'string' }, 
    { cartId: cartId, salesOrderId: salesOrderId, customerId: customerId, salesLineDataJSON: salesLineDataJSON }
  );
}

export function createBTGPTransactionByCartAsync(context: IContext, cartId: string,  salesOrderId: string,  customerId: string,  salesLineDataJSON: string): AsyncResult<string> {
  const request = createBTGPTransactionByCartInput(context.queryResultSettings || {}, cartId, salesOrderId, customerId, salesLineDataJSON);

  return callActionOrExecute<string>(request, context.callerContext);
}

function createBTGPControlHeaderAndDetailsRequest(): DataServiceQuery {
  return new DataServiceQuery();
}
export function createBTGPControlHeaderAndDetailsInput(queryResultSettings: IQueryResultSettings, controlTransactionId: string,  channel: number,  accountNum: string,  firstName: string, lastName: string, phone: string, email: string, detailsLineDataJson: string): IDataServiceRequest {
  const query = createBTGPControlHeaderAndDetailsRequest().resultSettings(queryResultSettings);
  return query.createDataServiceRequestForOperation(
    'CreateBTGPControlTable', true, '', 'false', 
    { bypassCache: 'get', returnEntity: 'string' }, 
    { controlTransactionId: controlTransactionId, channel: channel, accountNum: accountNum, firstName: firstName, lastName: lastName, phone: phone, email: email, detailsLineDataJson: detailsLineDataJson }
  );
}
export function createBTGPControlHeaderAndDetails(context: IContext, controlTransactionId: string,  channel: number,  accountNum: string,  firstName: string, lastName: string, phone: string, email: string, detailsLineDataJson: string): AsyncResult<string> {
  const request = createBTGPControlHeaderAndDetailsInput(context.queryResultSettings || {}, controlTransactionId,channel, accountNum,firstName,lastName, phone, email, detailsLineDataJson );
  return callActionOrExecute<string>(request, context.callerContext);
}


function createUploadImageFileToAzureRequest(): DataServiceQuery {
  return new DataServiceQuery();
}

export function createUploadImageFileToAzureInput(queryResultSettings: IQueryResultSettings, env: string, entity: string, fileName: string, base64Image: string, containerName: string): IDataServiceRequest {
  const query = createUploadImageFileToAzureRequest().resultSettings(queryResultSettings);
  return query.createDataServiceRequestForOperation(
    'PostFileToAzure', true, '', 'false', 
    { bypassCache: 'get', returnEntity: 'string' }, 
    { env: env, entity: entity, fileName: fileName,base64Image:base64Image, containerName: containerName }
  );
}

export function uploadImageFileToAzure(context: IContext, env: string, entity: string, fileName: string, base64Image: string,containerName: string): AsyncResult<string> {
  const request = createUploadImageFileToAzureInput(context.queryResultSettings || {}, env, entity,fileName,base64Image, containerName );
  return callActionOrExecute<string>(request, context.callerContext);
}

function createBTGPControlTableStatusRequest(): DataServiceQuery {
  return new DataServiceQuery();
}
export function createBTGPControlTableStatusInput(queryResultSettings: IQueryResultSettings, controlTransactionId: string,  checkoutStatus: number): IDataServiceRequest {
  const query = createBTGPControlTableStatusRequest().resultSettings(queryResultSettings);
  return query.createDataServiceRequestForOperation(
    'CreateBTGPControlTableStatus', true, '', 'false', 
    { bypassCache: 'get', returnEntity: 'string' }, 
    { controlTransactionId: controlTransactionId, checkoutStatus }
  );
}
export function createBTGPControlTableStatusAsync(context: IContext, controlTransactionId: string, checkoutStatus: number): AsyncResult<string> {
  const request = createBTGPControlTableStatusInput(context.queryResultSettings || {}, controlTransactionId, checkoutStatus );
  return callActionOrExecute<string>(request, context.callerContext);
}


function createBTGPTransactionRequest(): DataServiceQuery {
  return new DataServiceQuery();
}

export function createBTGPTransactionInput(queryResultSettings: IQueryResultSettings, isUat: boolean,  cartLineDataJSON: string): IDataServiceRequest {
  const query = createBTGPTransactionRequest().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'CreateBTGPTransaction', true, '', 'false', 
    { bypassCache: 'none', returnEntity: 'boolean' }, 
    { isUat: isUat, cartLineDataJSON: cartLineDataJSON }
  );
}

export function createBTGPTransactionAsync(context: IContext, isUat: boolean,  cartLineDataJSON: string): AsyncResult<boolean> {
  const request = createBTGPTransactionInput(context.queryResultSettings || {}, isUat, cartLineDataJSON);

  return callActionOrExecute<boolean>(request, context.callerContext);
}

function getBTGPCartLineRequest(): DataServiceQuery {
  return new DataServiceQuery();
}

export function getBTGPCartLineInput(queryResultSettings: IQueryResultSettings, cartLineID: string): IDataServiceRequest {
  const query = getBTGPCartLineRequest().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'GetBTGPCartLine', true, '', 'false', 
    { bypassCache: 'none', returnEntity: 'string' }, 
    { cartLineID: cartLineID }
  );
}

export function getBTGPCartLineAsync(context: IContext, cartLineID: string): AsyncResult<boolean> {
  const request = getBTGPCartLineInput(context.queryResultSettings || {}, cartLineID);

  return callActionOrExecute<boolean>(request, context.callerContext);
}

function getEventAvailabilityRequest(): DataServiceQuery {
  return new DataServiceQuery();
}

export function getEventAvailabilityInput(queryResultSettings: IQueryResultSettings,isUat: boolean, eventId: string): IDataServiceRequest {
  const query = getEventAvailabilityRequest().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'GetEventAvailability', true, '', 'false', 
    { bypassCache: 'none', returnEntity: 'string' }, 
    { isUat: isUat,eventId: eventId }
  );
}

export function getEventAvailabilityAsync(context: IContext, isUat: boolean, eventId: string ): AsyncResult<string[]> {
  const request = getEventAvailabilityInput(context.queryResultSettings || {}, isUat, eventId);

  return callActionOrExecute<string[]>(request, context.callerContext);
 
}

function createEventRegistrationRequest(): DataServiceQuery {
  return new DataServiceQuery();
}

export function createEventRegistrationInput(queryResultSettings: IQueryResultSettings,isUat: boolean, eventId: string, customerEmailId: string): IDataServiceRequest {
  const query = createEventRegistrationRequest().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'CreateEventRegistration', true, '', 'false', 
    { bypassCache: 'get', returnEntity: 'string' }, 
    { isUat: isUat,eventId: eventId, customerEmailId: customerEmailId }
  );
}

export function createEventRegistrationAsync(context: IContext, isUat: boolean, eventId: string, customerEmailId: string ): AsyncResult<boolean> {
  const request = createEventRegistrationInput(context.queryResultSettings || {}, isUat, eventId, customerEmailId);

  return callActionOrExecute<boolean>(request, context.callerContext);
 
}

function getAllBTGPCartLineRequest(): DataServiceQuery {
  return new DataServiceQuery();
}

export function getAllBTGPCartLineInput(queryResultSettings: IQueryResultSettings, cartID: string): IDataServiceRequest {
  const query = getAllBTGPCartLineRequest().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'GetAllBTGPCartLine', true, '', 'false', 
    { bypassCache: 'get', returnEntity: 'string[]' }, 
    { cartID: cartID }
  );
}

export function getAllBTGPCartLineAsync(context: IContext, cartID: string): AsyncResult<string[]> {
  const request = getAllBTGPCartLineInput(context.queryResultSettings || {}, cartID);

  return callActionOrExecute<string[]>(request, context.callerContext);
}

function checkAllBTGPCartLineRequest(): DataServiceQuery {
  return new DataServiceQuery();
}

export function checkAllBTGPCartLineInput(queryResultSettings: IQueryResultSettings, isUat: boolean,  cartID: string
): IDataServiceRequest {
  const query = checkAllBTGPCartLineRequest().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'CheckAllBTGPCartLine', true, '', 'false', 
    { bypassCache: 'get', returnEntity: 'string[]' }, 
    { isUat: isUat, cartID: cartID }
  );
}

export function checkAllBTGPCartLineAsync(context: IContext, isUat: boolean,  cartID: string
): AsyncResult<string[]> {
  const request = checkAllBTGPCartLineInput(context.queryResultSettings || {}, isUat, cartID);

  return callActionOrExecute<string[]>(request, context.callerContext);
}

function deleteBTGPCartLineRequest(): DataServiceQuery {
  return new DataServiceQuery();
}

export function deleteBTGPCartLineInput(queryResultSettings: IQueryResultSettings, cartLineID: string): IDataServiceRequest {
  const query = deleteBTGPCartLineRequest().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'DeleteBTGPCartLine', true, '', 'false', 
    { bypassCache: 'none', returnEntity: 'string' }, 
    { cartLineID: cartLineID }
  );
}

export function deleteBTGPCartLineAsync(context: IContext, cartLineID: string): AsyncResult<boolean> {
  const request = deleteBTGPCartLineInput(context.queryResultSettings || {}, cartLineID);
  
  return callActionOrExecute<boolean>(request, context.callerContext);
}

function deleteAllBTGPCartLineRequest(): DataServiceQuery {
  return new DataServiceQuery();
}

export function deleteAllBTGPCartLineInput(queryResultSettings: IQueryResultSettings, cartID: string): IDataServiceRequest {
  const query = deleteAllBTGPCartLineRequest().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'DeleteAllBTGPCartLine', true, '', 'false', 
    { bypassCache: 'none', returnEntity: 'boolean' }, 
    { cartID: cartID }
  );
}

export function deleteAllBTGPCartLineAsync(context: IContext, cartID: string): AsyncResult<boolean> {
  const request = deleteAllBTGPCartLineInput(context.queryResultSettings || {}, cartID);

  return callActionOrExecute<boolean>(request, context.callerContext);
}

function deleteInvalidBTGPCartLineRequest(): DataServiceQuery {
  return new DataServiceQuery();
}

export function deleteInvalidBTGPCartLineInput(queryResultSettings: IQueryResultSettings, cartLineID: string): IDataServiceRequest {
  const query = deleteInvalidBTGPCartLineRequest().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'DeleteInvalidBTGPCartLine', true, '', 'false', 
    { bypassCache: 'none', returnEntity: 'boolean' }, 
    { cartLineID: cartLineID }
  );
}

export function deleteInvalidBTGPCartLineAsync(context: IContext, cartLineID: string): AsyncResult<boolean> {
  const request = deleteInvalidBTGPCartLineInput(context.queryResultSettings || {}, cartLineID);

  return callActionOrExecute<boolean>(request, context.callerContext);
}

function deleteAllInvalidBTGPCartLineRequest(): DataServiceQuery {
  return new DataServiceQuery();
}

export function deleteAllInvalidBTGPCartLineInput(queryResultSettings: IQueryResultSettings, cartID: string): IDataServiceRequest {
  const query = deleteAllInvalidBTGPCartLineRequest().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'DeleteAllInvalidBTGPCartLine', true, '', 'false', 
    { bypassCache: 'none', returnEntity: 'boolean' }, 
    { cartID: cartID }
  );
}

export function deleteAllInvalidBTGPCartLineAsync(context: IContext, cartID: string): AsyncResult<boolean> {
  const request = deleteAllInvalidBTGPCartLineInput(context.queryResultSettings || {}, cartID);

  return callActionOrExecute<boolean>(request, context.callerContext);
}

function deleteAllValidBTGPCartLineRequest(): DataServiceQuery {
  return new DataServiceQuery();
}

export function deleteAllValidBTGPCartLineInput(queryResultSettings: IQueryResultSettings, cartID: string): IDataServiceRequest {
  const query = deleteAllValidBTGPCartLineRequest().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'DeleteAllValidBTGPCartLine', true, '', 'false', 
    { bypassCache: 'none', returnEntity: 'boolean' }, 
    { cartID: cartID }
  );
}

export function deleteAllValidBTGPCartLineAsync(context: IContext, cartID: string): AsyncResult<boolean> {
  const request = deleteAllValidBTGPCartLineInput(context.queryResultSettings || {}, cartID);

  return callActionOrExecute<boolean>(request, context.callerContext);
}

function createOrUpdateBTGPCartLineRequest(): DataServiceQuery {
  return new DataServiceQuery();
}

export function createOrUpdateBTGPCartLineInput(queryResultSettings: IQueryResultSettings, cartLineID: string,  cartID: string,  productID: string,  eventID: string,  eventName: string,  serialID: string,  serialNumber: string,  serialName: string,  name_1: string,  name_2: string,  name_3: string,  name_4: string,  name_5: string,  name_6: string,  name_7: string,  name_8: string,  name_9: string,  name_10: string,  name_11: string,  name_12: string,  name_13: string,  name_14: string,  name_15: string,  name_16: string,  name_17: string,  name_18: string,  name_19: string,  name_20: string,  remarks: string,  message: string,  category: string,  dedicatedBy: string,  hasTaxDeduction: boolean,  nric: string,  buildingName: string,  unitNumber: string,  postalCode: string,  birthDate: string,  phoneNumber: string,  schoolName: string,  donationOption: string,  blessingOption: string,  cartLineComment: string,  birthTime: string,  lightOption: string,  validFrom: string,  validTo: string,  parentCartLineID: string,  dedicationPeriod: string,  country: string,  companyName: string,  deceasedRelationship: string,  surgeryDate: string,  deathDate: string,  deathTime: string,  nameChange: string,  oldName_1: string,  oldName_2: string,  birthDate_2: string,  birthTime_2: string,  isValid: boolean,  invalidType: string,  inCart: boolean,  isSubProduct: boolean, startDate: string, gender: string,chineseName: string, nameNextKin: string, contactNumber: string, contactNumberNextKin: string, passportNumber: string,passportExpiryDate: string,passportIssuedDate: string, consent: number, isInsuranceIncluded: number): IDataServiceRequest {
  const query = createOrUpdateBTGPCartLineRequest().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'CreateOrUpdateBTGPCartLine', true, '', 'false', 
    { bypassCache: 'none', returnEntity: 'boolean' }, 
    { 
      cartLineID: cartLineID, cartID: cartID, productID: productID, eventID: eventID, eventName: eventName, serialID: serialID, serialNumber: serialNumber, serialName: serialName, name_1: name_1, name_2: name_2, name_3: name_3, name_4: name_4, name_5: name_5, name_6: name_6, name_7: name_7, name_8: name_8, name_9: name_9, name_10: name_10, name_11: name_11, name_12: name_12, name_13: name_13, name_14: name_14, name_15: name_15, name_16: name_16, name_17: name_17, name_18: name_18, name_19: name_19, name_20: name_20, remarks: remarks, message: message, category: category, dedicatedBy: dedicatedBy, hasTaxDeduction: hasTaxDeduction, nric: nric, buildingName: buildingName, unitNumber: unitNumber, postalCode: postalCode, birthDate: birthDate, phoneNumber: phoneNumber, schoolName: schoolName, donationOption: donationOption, blessingOption: blessingOption, cartLineComment: cartLineComment, birthTime: birthTime, lightOption: lightOption, validFrom: validFrom, validTo: validTo, parentCartLineID: parentCartLineID, dedicationPeriod: dedicationPeriod, country: country, companyName: companyName, deceasedRelationship: deceasedRelationship, surgeryDate: surgeryDate, deathDate: deathDate, deathTime: deathTime, nameChange: nameChange, oldName_1: oldName_1, oldName_2: oldName_2, birthDate_2: birthDate_2, birthTime_2: birthTime_2, isValid: isValid, invalidType: invalidType, inCart: inCart, isSubProduct: isSubProduct, startDate: startDate, gender: gender,
      chineseName: chineseName, contactNumber: contactNumber, nameNextKin: nameNextKin, contactNumberNextKin: contactNumberNextKin, passportNumber: passportNumber, passportExpiryDate:passportExpiryDate, passportIssuedDate:passportIssuedDate, consent:consent,
      isInsuranceIncluded:isInsuranceIncluded
    }
  );
}

export function createOrUpdateBTGPCartLineAsync(context: IContext, cartLineID: string,  cartID: string,  productID: string,  eventID: string,  eventName: string,  serialID: string,  serialNumber: string,  serialName: string,  name_1: string,  name_2: string,  name_3: string,  name_4: string,  name_5: string,  name_6: string,  name_7: string,  name_8: string,  name_9: string,  name_10: string,  name_11: string,  name_12: string,  name_13: string,  name_14: string,  name_15: string,  name_16: string,  name_17: string,  name_18: string,  name_19: string,  name_20: string,  remarks: string,  message: string,  category: string,  dedicatedBy: string,  hasTaxDeduction: boolean,  nric: string,  buildingName: string,  unitNumber: string,  postalCode: string,  birthDate: string,  phoneNumber: string,  schoolName: string,  donationOption: string,  blessingOption: string,  cartLineComment: string,  birthTime: string,  lightOption: string,  validFrom: string,  validTo: string,  parentCartLineID: string,  dedicationPeriod: string,  country: string,  companyName: string,  deceasedRelationship: string,  surgeryDate: string,  deathDate: string,  deathTime: string,  nameChange: string,  oldName_1: string,  oldName_2: string,  birthDate_2: string,  birthTime_2: string,  isValid: boolean,  invalidType: string,  inCart: boolean,  isSubProduct: boolean, startDate: string, gender: string, chineseName: string, nameNextKin: string, contactNumber: string, contactNumberNextKin: string,passportNumber: string,passportExpiryDate: string,passportIssuedDate: string, consent: number, isInsuranceIncluded: number ): AsyncResult<boolean> {
  const request = createOrUpdateBTGPCartLineInput(
      context.queryResultSettings || {}, cartLineID, cartID, productID, eventID, eventName, serialID, serialNumber, serialName, name_1, name_2, name_3, name_4, name_5, name_6, name_7, name_8, name_9, name_10, name_11, name_12, name_13, name_14, name_15, name_16, name_17, name_18, name_19, name_20, remarks, message, category, dedicatedBy, hasTaxDeduction, nric, buildingName, unitNumber, postalCode, birthDate, phoneNumber, schoolName, donationOption, blessingOption, cartLineComment, birthTime, lightOption, validFrom, validTo, parentCartLineID, dedicationPeriod, country, companyName, deceasedRelationship, surgeryDate, deathDate, deathTime, nameChange, oldName_1, oldName_2, birthDate_2, birthTime_2, isValid, invalidType, inCart, isSubProduct, startDate, gender,chineseName,
      nameNextKin,contactNumber,contactNumberNextKin,passportNumber, passportExpiryDate, passportIssuedDate, consent, isInsuranceIncluded
    );
  
  return callActionOrExecute<boolean>(request, context.callerContext);
}

function createBTGPErrorLogRequest(): DataServiceQuery {
  return new DataServiceQuery();
}

export function createBTGPErrorLogInput(queryResultSettings: IQueryResultSettings, errorLogID: string,  errorLogName: string,  errorLogDetails: string,  createdDate: string,  cartLineID: string,  cartID: string,  productID: string,  eventID: string,  eventName: string,  serialID: string,  serialNumber: string,  serialName: string,  name_1: string,  name_2: string,  name_3: string,  name_4: string,  name_5: string,  name_6: string,  name_7: string,  name_8: string,  name_9: string,  name_10: string,  name_11: string,  name_12: string,  name_13: string,  name_14: string,  name_15: string,  name_16: string,  name_17: string,  name_18: string,  name_19: string,  name_20: string,  remarks: string,  message: string,  category: string,  dedicatedBy: string,  hasTaxDeduction:boolean,  nric: string,  buildingName: string,  unitNumber: string,  postalCode: string,  birthDate: string,  phoneNumber: string,  schoolName: string,  donationOption: string,  blessingOption: string,  cartLineComment: string,  birthTime: string,  lightOption: string,  validFrom: string,  validTo: string,  parentCartLineID: string,  dedicationPeriod: string,  country: string,  companyName: string,  deceasedRelationship: string,  surgeryDate: string,  deathDate: string,  deathTime: string,  nameChange: string,  oldName_1: string,  oldName_2: string,  birthDate_2: string,  birthTime_2: string, startDate: string, gender: string, chineseName: string, contactNumber: string,  nameNextKin: string, contactNumberNextKin: string,passportNumber: string,passportExpiryDate: string,passportIssuedDate: string): IDataServiceRequest {
  const query = createBTGPErrorLogRequest().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'CreateBTGPErrorLog', true, '', 'false', 
    { bypassCache: 'none', returnEntity: 'boolean' }, 
    { 
      errorLogID: errorLogID, errorLogName: errorLogName, errorLogDetails: errorLogDetails, createdDate: createdDate, cartLineID: cartLineID, cartID: cartID, productID: productID, eventID: eventID, eventName: eventName, serialID: serialID, serialNumber: serialNumber, serialName: serialName, name_1: name_1, name_2: name_2, name_3: name_3, name_4: name_4, name_5: name_5, name_6: name_6, name_7: name_7, name_8: name_8, name_9: name_9, name_10: name_10, name_11: name_11, name_12: name_12, name_13: name_13, name_14: name_14, name_15: name_15, name_16: name_16, name_17: name_17, name_18: name_18, name_19: name_19, name_20: name_20, remarks: remarks, message: message, category: category, dedicatedBy: dedicatedBy, hasTaxDeduction: hasTaxDeduction, nric: nric, buildingName: buildingName, unitNumber: unitNumber, postalCode: postalCode, birthDate: birthDate, phoneNumber: phoneNumber, schoolName: schoolName, donationOption: donationOption, blessingOption: blessingOption, cartLineComment: cartLineComment, birthTime: birthTime, lightOption: lightOption, validFrom: validFrom, validTo: validTo, parentCartLineID: parentCartLineID, dedicationPeriod: dedicationPeriod, country: country, companyName: companyName, deceasedRelationship: deceasedRelationship, surgeryDate: surgeryDate, deathDate: deathDate, deathTime: deathTime, nameChange: nameChange, oldName_1: oldName_1, oldName_2: oldName_2, birthDate_2: birthDate_2, birthTime_2: birthTime_2 , startDate: startDate, gender: gender, chineseName: chineseName, contactNumber: contactNumber, nameNextKin: nameNextKin, contactNumberNextKin: contactNumberNextKin, passportNumber: passportNumber, passportExpiryDate:passportExpiryDate, passportIssuedDate:passportIssuedDate
    }
  );
}

export function createBTGPErrorLogAsync(context: IContext, errorLogID: string,  errorLogName: string,  errorLogDetails: string,  createdDate: string,  cartLineID: string,  cartID: string,  productID: string,  eventID: string,  eventName: string,  serialID: string,  serialNumber: string,  serialName: string,  name_1: string,  name_2: string,  name_3: string,  name_4: string,  name_5: string,  name_6: string,  name_7: string,  name_8: string,  name_9: string,  name_10: string,  name_11: string,  name_12: string,  name_13: string,  name_14: string,  name_15: string,  name_16: string,  name_17: string,  name_18: string,  name_19: string,  name_20: string,  remarks: string,  message: string,  category: string,  dedicatedBy: string,  hasTaxDeduction:boolean,  nric: string,  buildingName: string,  unitNumber: string,  postalCode: string,  birthDate: string,  phoneNumber: string,  schoolName: string,  donationOption: string,  blessingOption: string,  cartLineComment: string,  birthTime: string,  lightOption: string,  validFrom: string,  validTo: string,  parentCartLineID: string,  dedicationPeriod: string,  country: string,  companyName: string,  deceasedRelationship: string,  surgeryDate: string,  deathDate: string,  deathTime: string,  nameChange: string,  oldName_1: string,  oldName_2: string,  birthDate_2: string,  birthTime_2: string, startDate: string, gender: string, chineseName: string, contactNumber: string,  nameNextKin: string, contactNumberNextKin: string,passportNumber: string,passportExpiryDate: string,passportIssuedDate: string): AsyncResult<boolean> {
  const request = createBTGPErrorLogInput(
      context.queryResultSettings || {}, errorLogID, errorLogName, errorLogDetails, createdDate, cartLineID, cartID, productID, eventID, eventName, serialID, serialNumber, serialName, name_1, name_2, name_3, name_4, name_5, name_6, name_7, name_8, name_9, name_10, name_11, name_12, name_13, name_14, name_15, name_16, name_17, name_18, name_19, name_20, remarks, message, category, dedicatedBy, hasTaxDeduction, nric, buildingName, unitNumber, postalCode, birthDate, phoneNumber, schoolName, donationOption, blessingOption, cartLineComment, birthTime, lightOption, validFrom, validTo, parentCartLineID, dedicationPeriod, country, companyName, deceasedRelationship, surgeryDate, deathDate, deathTime, nameChange, oldName_1, oldName_2, birthDate_2, birthTime_2, startDate, gender,
      chineseName, contactNumber, nameNextKin, contactNumberNextKin, passportNumber, passportExpiryDate, passportIssuedDate
    );

  return callActionOrExecute<boolean>(request, context.callerContext);
}

function getAllBTGPDraftRequest(): DataServiceQuery {
  return new DataServiceQuery();
}

export function getAllBTGPDraftInput(queryResultSettings: IQueryResultSettings, customerID: string,  productID: string): IDataServiceRequest {
  const query = getAllBTGPDraftRequest().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'GetAllBTGPDraft', true, '', 'false', 
    { bypassCache: 'get', returnEntity: 'string[]' }, 
    { customerID: customerID, productID: productID }
  );
}

export function getAllBTGPDraftAsync(context: IContext, customerID: string,  productID: string): AsyncResult<string[]> {
  const request = getAllBTGPDraftInput(context.queryResultSettings || {}, customerID, productID);

  return callActionOrExecute<string[]>(request, context.callerContext);
}

function deleteBTGPDraftQuery(): DataServiceQuery {
  return new DataServiceQuery();
}

export function deleteBTGPDraftInput(customerID: string, productID: string): IDataServiceRequest {
  const query = deleteBTGPDraftQuery();

  return query.createDataServiceRequestForOperation(
    'DeleteBTGPDraft', true, '', 'false', 
    { bypassCache: 'get', returnEntity: 'boolean' }, 
    { customerID: customerID, productID: productID });
}

export function deleteBTGPDraftAsync(context: IContext, customerID: string, productID: string): AsyncResult<boolean> {
  const request = deleteBTGPDraftInput(customerID, productID);

  return callActionOrExecute<boolean>(request, context.callerContext);
}

function createOrUpdateBTGPDraftRequest(): DataServiceQuery {
  return new DataServiceQuery();
}

export function createOrUpdateBTGPDraftInput(queryResultSettings: IQueryResultSettings, draftID: string,  customerID: string,  productID: string,  eventID: string,  eventName: string,  serialID: string,  serialNumber: string,  serialName: string,  name_1: string,  name_2: string,  name_3: string,  name_4: string,  name_5: string,  name_6: string,  name_7: string,  name_8: string,  name_9: string,  name_10: string,  name_11: string,  name_12: string,  name_13: string,  name_14: string,  name_15: string,  name_16: string,  name_17: string,  name_18: string,  name_19: string,  name_20: string,  remarks: string,  message: string,  category: string,  dedicatedBy: string,  hasTaxDeduction: boolean,  nric: string,  buildingName: string,  unitNumber: string,  postalCode: string,  birthDate: string,  phoneNumber: string,  schoolName: string,  donationOption: string,  blessingOption: string,  isValid: string,  modifiedDatetime: string,  birthTime: string,  lightOption: string,  validFrom: string,  validTo: string,  parentDraftID: string,  dedicationPeriod: string,  country: string,  companyName: string,  deceasedRelationship: string,  surgeryDate: string,  deathDate: string,  deathTime: string,  quantity: number,  nameChange: string,  oldName_1: string,  oldName_2: string,  birthDate_2: string,  birthTime_2: string, startDate: string, gender: string, chineseName: string, contactNumber: string, nameNextKin: string, contactNumberNextKin : string,passportNumber: string, passportExpiryDate: string,passportIssuedDate: string, consent: number,
isInsuranceIncluded: number): IDataServiceRequest {
  const query = createOrUpdateBTGPDraftRequest().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'CreateOrUpdateBTGPDraft', true, '', 'false', 
    { bypassCache: 'none', returnEntity: 'boolean' }, 
    { 
      draftID: draftID, customerID: customerID, productID: productID, eventID: eventID, eventName: eventName, serialID: serialID, serialNumber: serialNumber, serialName: serialName, name_1: name_1, name_2: name_2, name_3: name_3, name_4: name_4, name_5: name_5, name_6: name_6, name_7: name_7, name_8: name_8, name_9: name_9, name_10: name_10, name_11: name_11, name_12: name_12, name_13: name_13, name_14: name_14, name_15: name_15, name_16: name_16, name_17: name_17, name_18: name_18, name_19: name_19, name_20: name_20, remarks: remarks, message: message, category: category, dedicatedBy: dedicatedBy, hasTaxDeduction: hasTaxDeduction, nric: nric, buildingName: buildingName, unitNumber: unitNumber, postalCode: postalCode, birthDate: birthDate, phoneNumber: phoneNumber, schoolName: schoolName, donationOption: donationOption, blessingOption: blessingOption, isValid: isValid, modifiedDatetime: modifiedDatetime, birthTime: birthTime, lightOption: lightOption, validFrom: validFrom, validTo: validTo, parentDraftID: parentDraftID, dedicationPeriod: dedicationPeriod, country: country, companyName: companyName, deceasedRelationship: deceasedRelationship, surgeryDate: surgeryDate, deathDate: deathDate, deathTime: deathTime, quantity: quantity, nameChange: nameChange, oldName_1: oldName_1, oldName_2: oldName_2, birthDate_2: birthDate_2, birthTime_2: birthTime_2, startDate: startDate, gender: gender, chineseName: chineseName,
      contactNumber: contactNumber,  nameNextKin: nameNextKin, contactNumberNextKin: contactNumberNextKin,passportNumber: passportNumber, passportExpiryDate:passportExpiryDate, passportIssuedDate:passportIssuedDate, consent:consent, isInsuranceIncluded:isInsuranceIncluded
    }
  );
}

export function createOrUpdateBTGPDraftAsync(context: IContext, draftID: string,  customerID: string,  productID: string,  eventID: string, eventName: string,  serialID: string,  serialNumber: string,  serialName: string,  name_1: string,  name_2: string,  name_3: string,  name_4: string,  name_5: string,  name_6: string,  name_7: string,  name_8: string,  name_9: string,  name_10: string,  name_11: string,  name_12: string,  name_13: string,  name_14: string,  name_15: string,  name_16: string,  name_17: string,  name_18: string,  name_19: string,  name_20: string,  remarks: string,  message: string,  category: string,  dedicatedBy: string,  hasTaxDeduction: boolean,  nric: string,  buildingName: string,  unitNumber: string,  postalCode: string,  birthDate: string,  phoneNumber: string, schoolName: string,  donationOption: string,  blessingOption: string,  isValid: string,  modifiedDatetime: string,  birthTime: string,  lightOption: string,  validFrom: string,  validTo: string,  parentDraftID: string,  dedicationPeriod: string,  country: string,  companyName: string,  deceasedRelationship: string,  surgeryDate: string,  deathDate: string,  deathTime: string,  quantity: number,  nameChange: string,  oldName_1: string,  oldName_2: string,  birthDate_2: string,  birthTime_2: string, startDate: string, gender: string, chineseName: string, contactNumber: string, nameNextKin: string, contactNumberNextKin : string,passportNumber: string, passportExpiryDate: string,passportIssuedDate: string, consent: number, isInsuranceIncluded: number ): AsyncResult<boolean> {
  const request = createOrUpdateBTGPDraftInput(
    context.queryResultSettings || {}, draftID, customerID, productID, eventID, eventName, serialID, serialNumber, serialName, name_1, name_2, name_3, name_4, name_5, name_6, name_7, name_8, name_9, name_10, name_11, name_12, name_13, name_14, name_15, name_16, name_17, name_18, name_19, name_20, remarks, message, category, dedicatedBy, hasTaxDeduction, nric, buildingName, unitNumber, postalCode, birthDate, phoneNumber, schoolName, donationOption, blessingOption, isValid, modifiedDatetime, birthTime, lightOption, validFrom, validTo, parentDraftID, dedicationPeriod, country, companyName, deceasedRelationship, surgeryDate, deathDate, deathTime, quantity, nameChange, oldName_1, oldName_2, birthDate_2, birthTime_2, startDate, gender, chineseName, contactNumber, nameNextKin, contactNumberNextKin, passportNumber, passportExpiryDate, passportIssuedDate, consent, isInsuranceIncluded
  );

  return callActionOrExecute<boolean>(request, context.callerContext);
}

function getProductEventsByIdQuery(): DataServiceQuery {
  return new DataServiceQuery();
}

export function getProductEventsByIdInput(queryResultSettings: IQueryResultSettings, isUat: boolean,  startDate: string,  ecommId: string): IDataServiceRequest {
  const query = getProductEventsByIdQuery().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'GetProductEventsById', false, '', 'true', 
    { bypassCache: 'none', returnEntity: 'string[]' }, 
    { isUat: isUat, startDate: startDate, ecommId: ecommId }
  );
}

export function getProductEventsByIdAsync(context: IContext, isUat: boolean, startDate: string, ecommId: string): AsyncResult<string[]> {
  const request = getProductEventsByIdInput(context.queryResultSettings || {}, isUat, startDate, ecommId);

  return callActionOrExecute<string[]>(request, context.callerContext);
}

function getProductEventsByIdsQuery(): DataServiceQuery {
  return new DataServiceQuery();
}

export function getProductEventsByIdsInput(queryResultSettings: IQueryResultSettings, isUat: boolean,  startDate: string,  ecommIds: string): IDataServiceRequest {
  const query = getProductEventsByIdsQuery().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'GetProductEventsByIds', false, '', 'false', 
    { bypassCache: 'none', returnEntity: 'string' }, 
    { isUat: isUat, startDate: startDate, ecommIds: ecommIds }
  );
}

export function getProductEventsByIdsAsync(context: IContext, isUat: boolean, startDate: string, ecommIds: string): AsyncResult<string> {
  const request = getProductEventsByIdsInput(context.queryResultSettings || {}, isUat, startDate, ecommIds);

  return callActionOrExecute<string>(request, context.callerContext);
}

function getEventDetailsRequest(): DataServiceQuery {
  return new DataServiceQuery();
}

export function getEventDetailsInput(queryResultSettings: IQueryResultSettings, isUat: boolean, eventId: string): IDataServiceRequest {
  const query = getEventDetailsRequest().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'GetEventDetails', true, '', 'false', 
    { bypassCache: 'none', returnEntity: 'string' }, 
    { isUat: isUat, eventId: eventId }
  );
}

export function getEventDetailsAsync(context: IContext, isUat: boolean, eventId: string): AsyncResult<string> {
  const request = getEventDetailsInput(context.queryResultSettings || {}, isUat, eventId);

  return callActionOrExecute<string>(request, context.callerContext);
}

function getContactDetailsQuery(): DataServiceQuery {
  return new DataServiceQuery();
}

export function getContactDetailsInput(queryResultSettings: IQueryResultSettings, email: string, isUat: boolean): IDataServiceRequest {
  const query = getContactDetailsQuery().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'GetContactDetails', false, '', 'true', 
    { bypassCache: 'none', returnEntity: 'string[]' }, 
    { email: email, isUat: isUat }
  );
}

export function getContactDetailsAsync(context: IContext, email: string, isUat: boolean): AsyncResult<string[]> {
  const request = getContactDetailsInput(context.queryResultSettings || {}, email, isUat);

  return callActionOrExecute<string[]>(request, context.callerContext);
}

function createOrderRequestFOMOQuery(): DataServiceQuery {
  return new DataServiceQuery();
}

export function createOrderRequestFOMOInput(entity: string, mode: string, orderNo: string, subject: string, amount: string, returnUrl: string, backUrl: string, sourceOfFund: string): IDataServiceRequest {
  const query = createOrderRequestFOMOQuery();

  return query.createDataServiceRequestForOperation(
    'CreateOrderRequestFOMO', true, '', 'false', 
    { bypassCache: 'get', returnEntity: 'string' }, 
    {
      entity: entity, mode: mode, orderNo: orderNo, subject: subject, 
      amount: amount, returnUrl: returnUrl, backUrl: backUrl, sourceOfFund: sourceOfFund
    }
  );
}

export function createOrderRequestFOMOAsync(context: IContext, entity: string, mode: string, orderNo: string, subject: string, amount: string, returnUrl: string, backUrl: string, sourceOfFund: string): AsyncResult<string> {
  const request = createOrderRequestFOMOInput(entity, mode, orderNo, subject, amount, returnUrl, backUrl, sourceOfFund);

  return callActionOrExecute<string>(request, context.callerContext);
}

function getOrderFOMOQuery(): DataServiceQuery {
  return new DataServiceQuery();
}

export function getOrderFOMOInput(entity: string, orderId: string): IDataServiceRequest {
  const query = getOrderFOMOQuery();

  return query.createDataServiceRequestForOperation('GetOrderFOMO', false, '', 'false', 
    { bypassCache: 'get', returnEntity: 'string' }, 
    { entity: entity, orderId: orderId }
  );
}

export function getOrderFOMOAsync(context: IContext, entity: string, orderId: string): AsyncResult<string> {
  const request = getOrderFOMOInput(entity, orderId);

  return callActionOrExecute<string>(request, context.callerContext);
}

function getAllBTGPErrorLogByDateQuery(): DataServiceQuery {
  return new DataServiceQuery();
}

export function getAllBTGPErrorLogByDateInput (queryResultSettings: IQueryResultSettings, fromDate: string, toDate: string, numberOfRecords: number): IDataServiceRequest {
  const query = getAllBTGPErrorLogByDateQuery().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'GetAllBTGPErrorLogByDate', true, 
    '', 'true', 
    { bypassCache: 'get', returnEntity: 'string[]' }, { 
      fromDate: fromDate, toDate: toDate, numberOfRecords: numberOfRecords
    }
  );
}

export function getAllBTGPErrorLogByDateAsync (context: IContext, fromDate: string, toDate: string, numberOfRecords: number): AsyncResult<string[]> {
  const request = getAllBTGPErrorLogByDateInput(context.queryResultSettings || {}, fromDate, toDate, numberOfRecords);

  return callActionOrExecute<string[]>(request, context.callerContext);
}

function updateContactQuery(): DataServiceQuery {
  return new DataServiceQuery();
}

export function updateContactInput (queryResultSettings: IQueryResultSettings, firstname: string, lastname: string, mobilephone: string, gmb_fullnamechinese: string, address1_country: string, address1_city: string, address1_postalcode: string, gmb_unitnofloorapartmentno: string, gmb_blockno: string, address1_line1: string, gmb_buildingname: string, gmb_buildingno: string, donotbulkemail: string, gmb_donotflyer: string, gmb_donotsms: string, gmb_donotnewsletter: string, gmb_donotemailgp: string, gmb_donotflyergp: string, gmb_donotsmsgp: string, gmb_donotnewslettergp: string, emailaddress1: string, birthdate: string, isUat: boolean): IDataServiceRequest {
  const query = updateContactQuery().resultSettings(queryResultSettings);

  return query.createDataServiceRequestForOperation(
    'UpdateContact', true, '', 'true',  { bypassCache: 'get', returnEntity: 'string' },  { 
      firstname: firstname, lastname: lastname, mobilephone: mobilephone, gmb_fullnamechinese: gmb_fullnamechinese, address1_country: address1_country, address1_city: address1_city, address1_postalcode: address1_postalcode, gmb_unitnofloorapartmentno: gmb_unitnofloorapartmentno, gmb_blockno: gmb_blockno, address1_line1: address1_line1, gmb_buildingname: gmb_buildingname, gmb_buildingno: gmb_buildingno, donotbulkemail: donotbulkemail, gmb_donotflyer: gmb_donotflyer, gmb_donotsms: gmb_donotsms, gmb_donotnewsletter: gmb_donotnewsletter, gmb_donotemailgp: gmb_donotemailgp, gmb_donotflyergp: gmb_donotflyergp, gmb_donotsmsgp: gmb_donotsmsgp, gmb_donotnewslettergp: gmb_donotnewslettergp, emailaddress1: emailaddress1, birthdate: birthdate, isUat: isUat
    }
  );
}

export function updateContactAsync (context: IContext, firstname: string, lastname: string, mobilephone: string, gmb_fullnamechinese: string, address1_country: string, address1_city: string, address1_postalcode: string, gmb_unitnofloorapartmentno: string, gmb_blockno: string, address1_line1: string, gmb_buildingname: string, gmb_buildingno: string, donotbulkemail: string, gmb_donotflyer: string, gmb_donotsms: string, gmb_donotnewsletter: string, gmb_donotemailgp: string, gmb_donotflyergp: string, gmb_donotsmsgp: string, gmb_donotnewslettergp: string, emailaddress1: string, birthdate: string, isUat: boolean): AsyncResult<string[]> {
  const request = updateContactInput(context.queryResultSettings || {}, firstname, lastname, mobilephone, gmb_fullnamechinese, address1_country, address1_city, address1_postalcode, gmb_unitnofloorapartmentno, gmb_blockno, address1_line1, gmb_buildingname, gmb_buildingno, donotbulkemail, gmb_donotflyer, gmb_donotsms, gmb_donotnewsletter, gmb_donotemailgp, gmb_donotflyergp, gmb_donotsmsgp, gmb_donotnewslettergp, emailaddress1, birthdate, isUat);

  return callActionOrExecute<string[]>(request, context.callerContext);
}

function calculateTotalItemWeightRequest(): DataServiceQuery {
  return new DataServiceQuery();
}
export function calculateTotalItemWeightInput(queryResultSettings: IQueryResultSettings, itemIds: string, itemCounts: string): IDataServiceRequest {
  const query = calculateTotalItemWeightRequest().resultSettings(queryResultSettings);
  return query.createDataServiceRequestForOperation(
    'CalculateTotalItemWeight', true, '', 'false', 
    { bypassCache: 'get', returnEntity: 'number' }, 
    { itemIds, itemCounts }
  );
}
export function calculateTotalItemWeight(context: IContext, itemIds: string, itemCounts: string): AsyncResult<number> {
  const request = calculateTotalItemWeightInput(context.queryResultSettings || {}, itemIds, itemCounts);
  return callActionOrExecute<number>(request, context.callerContext);
}

function eshopDeliveryModeDetailsRequest(): DataServiceQuery {
  return new DataServiceQuery();
}
export function eshopDeliveryModeDetailsInput(queryResultSettings: IQueryResultSettings, channelId: string, languageId: string, isUat: boolean): IDataServiceRequest {
  const query = eshopDeliveryModeDetailsRequest().resultSettings(queryResultSettings);
  return query.createDataServiceRequestForOperation(
    'getEshopDeliveryModeDetails', true, '', 'false', 
    { bypassCache: 'none', returnEntity: 'string' }, 
    { channelId, languageId, isUat }
  );
}
export function getEshopDeliveryModeDetails(context: IContext, channelId: string, languageId: string, isUat: boolean): AsyncResult<string> {
  const request = eshopDeliveryModeDetailsInput(context.queryResultSettings || {}, channelId, languageId, isUat);
  return callActionOrExecute<string>(request, context.callerContext);
}